var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
const SvgContacted = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 512 512",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M403.8 148.1C403.8 66.5 337.4.2 255.9.2s-148 66.3-148 147.9c0 50.5 25.5 95.2 64.2 121.9-36.2 12.5-69.4 33.1-97.2 61C26.6 379.3 0 443.5 0 511.9h40c0-119 96.8-215.9 215.9-215.9 81.5 0 147.9-66.4 147.9-147.9zm-255.9 0c0-59.5 48.4-107.9 107.9-107.9s107.9 48.4 107.9 107.9S315.4 256 255.9 256s-108-48.4-108-107.9zM474.9 291.8L320.6 445.9l-68.3-68.3-25.4 25.7 93.7 93.9 180.1-179.9z"
  })));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgContacted, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/contacted.8d5b347a.svg";
export { ForwardRef as ReactComponent };